<template>
  <div class="flex flex-wrap justify-center small-padding-left small-padding-right">
    <div class="write-letter-editor">
      <div class="columns">
        <div class="edit-column left-background">
          <div class="left-logo">
            <img
              :src="'https://static.cdn.annoanno.net/cut-letter/logo.png'"
            />
          </div>
          <wysiwyg
            ref="wysiwyg-1"
            id="row1"
            v-model="leftletter"
            @input.native="inputHandle"
            @keydown.native="leftLetterHandle"

          />
        </div>
        <div class="edit-column">
          <div style="margin-top: 100px;" v-html="showQRletter" />
          <div class="right-logo">
            <img
              :src="'https://static.cdn.annoanno.net/cut-letter/logo.png'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import wysiwyg from 'vue-wysiwyg-fixed'
import QRCodeStyling, {
  DrawType,
  TypeNumber,
  Mode,
  ErrorCorrectionLevel,
  DotType,
  CornerSquareType,
  CornerDotType,
  Extension
} from 'qr-code-styling'

Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    table: true,
    justifyRight: true,
    headings: true,
    separator: true,
    removeFormat: true,
    unorderedList: true,
    orderedList: true
  },
  maxHeight: '1050px',
  forcePlainTextOnPaste: true
})

var timeoutId

export default {
  name: 'StylistLetterModal',
  props: [
    'letter',
    'saveLetter',
    'locale'
  ],

  data () {
    return {
      orderId: null,
      qrCodeBase64: '',
      manualPart2: '<b>See an online representation of your outfits</b><br><br>This is the exciting part! It’s time to see the outfits that have been put together personally for you.<br> There are two ways you can see the outfits I have put together for you:<br><br> <span>&#x25cf;</span>&nbsp; Click on the link in the email we sent you<br> OR<br> <span>&#x25cf;</span>&nbsp; Scan the QR code below with the camera on your phone<br>'
    }
  },
  created () {
    window.addEventListener('beforeunload', this.updateLetter())

    this.$emit('changeLetter')
    this.generateQRcode()
  },
  beforeDestroy () {
    this.updateLetter()
  },
  watch: {
    saveLetter (value) {
      if (!value) { // changed letter
        this.updateLetter()
      }
    }
  },
  computed: {
    leftletter: {
      get: function () {
        return this.letter.column_1
      },
      set: function (val) {
        this.letter.column_1 = val
      }
    },
    showQRletter () {
      var letter = this.letter.column_2
      const qrcodePos = this.letter.column_2.indexOf('id="qrCodeView"')
      if (qrcodePos > 0) {
        letter = this.addZoomStyle(this.letter.column_2, qrcodePos)
      } else {
        this.$emit('changeLetter')
        letter = this.letter.column_2 + '<br><br><br><br>' + `<div class="qr-code text-center"><img style="zoom: 50%;" id="qrCodeView" src="${this.qrCodeBase64}"/></div>` + ''
      }
      return letter
    },
    rightletter () {
      var letter = this.letter.column_2
      if (this.letter.column_2.includes('qrCodeView')) {
        letter = this.letter.column_2
      } else {
        this.$emit('changeLetter')
        letter = this.letter.column_2 + '<br><br><br><br>' + `<div class="qr-code text-center"><img id="qrCodeView" src="${this.qrCodeBase64}"/></div>` + ''
      }
      return letter
    }
  },
  methods: {
    addZoomStyle (str, index) {
      return str.substring(0, index) + 'style="zoom: 50%;" ' + str.substring(index, str.length)
    },
    generateQRcode () {
      let domainUrl = process.env.VUE_APP_WEBSITE_URL.replace('.dk', this.locale ? '.' + this.locale.toLowerCase() : '.dk')
      if (process.env.VUE_APP_WEBSITE_URL.includes('.net')) {
        domainUrl = process.env.VUE_APP_WEBSITE_URL.replace('.net', this.locale ? '.' + this.locale.toLowerCase() : '.dk')
      }
      const dataUrl = `${domainUrl}/outfits/?order=${this.$route.query.key}&qrcode=1&utm_annoanno_source=QR&utm_annoanno_identifier=styling_letter&utm_annoanno_app=outfits`
      const options = {
        width: 600,
        height: 600,
        type: 'png',
        data: dataUrl,
        image: '/img/qr-logo.svg',
        margin: 10,
        qrOptions: {
          typeNumber: 0,
          mode: 'Byte',
          errorCorrectionLevel: 'Q'
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0
        },
        dotsOptions: {
          color: '#000000',
          type: 'dots'
        },
        backgroundOptions: {
          color: '#ffffff'
        },
        cornersSquareOptions: {
          color: '#000000',
          type: 'extra-rounded',
          gradient: null
        },
        cornersDotOptions: {
          color: '#000000',
          type: ''
        }
      }
      const qrCode = new QRCodeStyling(options)
      qrCode.getRawData('png').then((buffer) => {
        this.blobToBase64(buffer).then(data => {
          this.qrCodeBase64 = data
        })
      })
    },
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },
    updateLetter () {
      this.$emit('saveLetter')
      Vue.api.patch('/order/letter', {
        orderId: this.$route.query.id,
        col1: this.leftletter,
        col2: this.rightletter
      }, {
        callback: () => {}
      })
    },
    leftLetterHandle (e) {
      const hasScrollBar = e.target.scrollHeight > e.target.clientHeight
      if (hasScrollBar) {
        e.target.classList.add('unhappy')
        if ([8, 46].indexOf(event.which) == -1) {
          event.preventDefault()
        }
      } else e.target.classList.remove('unhappy')
    },
    inputHandle (e) {
      this.$emit('changeLetter')
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        this.updateLetter()
      }, 1000)
    },
    keyHandle (e) {
      event.preventDefault()
    }
  }
}
</script>

<style lang="less" scoped>
@import "~vue-wysiwyg-fixed/dist/vueWysiwyg.css";

.outer-style {
  transition: 200ms;
}
.columns {
  display: flex;
}
.columns .edit-column {
  position: relative;
  width: 625px;
  height: 1100px;
  padding-top: 30px;
  padding-bottom: 40px;
  font-family: Montserrat;
  font-size: 22px;
  line-height: 34px;
  font-weight: normal;
}
.edit-column .left-logo {
  position: absolute;
  top: -50px;
  left: 280px;
  background: #fff;
  text-align: center;
  width: 80px;

  img {
    height: 80px;
  }
}
.left-background::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-image: url("/img/qr-logo.svg");
  background-size: 500px;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.1;
}

.edit-column .right-logo {
  position: absolute;
  bottom: -50px;
  left: 280px;
  background: #fff;
  text-align: center;
  width: 80px;

  img {
    height: 80px;
  }
}
.edit-column .preview-logo img {
  height: 80px;
}
.columns .edit-column:nth-child(1) {
  margin-right: 80px;
}
.columns .edit-column:nth-child(2) {
  margin-left: 20px;
}
.write-letter-editor {
  margin: 60px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  border: 2px solid lightgray;
  width: 1435px;
  display: flex;
  justify-content: center;
}
/deep/.editr {
  position: relative;
  border: none;
}
/deep/.editr .editr--toolbar {
  position: absolute;
  top: -36px;
  display: none;
}
/deep/.columns .edit-column:hover .editr--toolbar {
  display: flex;
}
.buttons {
  position: fixed;
  left: 15px;
  top: 0px;
  bottom: 0px;
  display: flex;
  /*align-items: center;*/
  justify-content: center;
  flex-direction: column;
}
.buttons button {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.editr--content {
  padding: 0px;
  height: 1100px;
  margin-top: 100px;
}
/deep/.editr--content.unhappy {
  border: 3px solid red;
}
</style>
